import { gql } from "@apollo/client";
import { client } from "api";

interface QueryParams {
  params: {
    documentId?: number;
    identityFileId?: number;
  };
}

interface QueryResult {
  getDocumentFileBase64: string | null;
}

export const getDocumentFileBase64 = async (
  params: QueryParams["params"],
): Promise<string | null> => {
  const response = await client.query<QueryResult, QueryParams>({
    query: gql`
      query GetDocumentFileBase64($params: GetDocumentFileParams!) {
        getDocumentFileBase64(params: $params)
      }
    `,
    variables: { params },
    fetchPolicy: "no-cache",
  });
  return response.data?.getDocumentFileBase64 ?? null;
};
